<template>
    <slot name="toggle" :toggle="() => show = ! show" :show="show"></slot>

    <span v-if="show" v-bind="$attrs">
        <slot></slot>
    </span>
</template>

<script>
export default {
    name: "hider",
    inheritAttrs: false,
    props: {
        active: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            show: false,
        }
    },
    mounted() {
        if (this.active) {
            this.show = this.active;
        }
    },
}
</script>

<style scoped>

</style>
